import { render, staticRenderFns } from "./residentialQuarters.vue?vue&type=template&id=3412b96e&scoped=true&"
import script from "./residentialQuarters.vue?vue&type=script&lang=js&"
export * from "./residentialQuarters.vue?vue&type=script&lang=js&"
import style0 from "./residentialQuarters.vue?vue&type=style&index=0&id=3412b96e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3412b96e",
  null
  
)

export default component.exports